import React from 'react';
import PropTypes from 'prop-types';
import flow from 'lodash/fp/flow';
import filter from 'lodash/fp/filter';
import identity from 'lodash/fp/identity';
import join from 'lodash/fp/join';

function PropertyAddress({
  propertyAddress: {
    line1,
    line2,
    city,
    state,
    zipcode,
  },
  isAutoReleaseDesign,
  orderDetailsUrl,
  orderNumber,
}) {
  const address = flow(
    filter(identity),
    join(' '),
  )([line1, line2, city, state, zipcode]);
  const viewAddressOnMap = () => {
    window.open(`https://www.google.com/maps?q=${address}`, '_blank');
  };

  return (
    <div>
      <div className="propertyAddress pointer" role="button" tabIndex="0" onClick={viewAddressOnMap} title="View address on map">
        <h2>Property Address</h2>
        <div className="address">
          <img src="//media.blinds.com/infopages/images/mandi/mandi-address.png" className="w2" alt="View address on map" />
          {address}
        </div>
      </div>
      {isAutoReleaseDesign &&
        <div className="autoReleaseDesign" >Order Number: <a className="link pointer underline blue hover-orange" target="_blank" rel="noopener noreferrer" href={orderDetailsUrl}>#{orderNumber}</a></div>
      }
    </div>
  );
}

PropertyAddress.propTypes = {
  propertyAddress: PropTypes.shape({
    line1: PropTypes.string.isRequired,
    line2: PropTypes.string,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zipcode: PropTypes.string.isRequired,
  }).isRequired,
  isAutoReleaseDesign: PropTypes.bool.isRequired,
  orderDetailsUrl: PropTypes.string.isRequired,
  orderNumber: PropTypes.string.isRequired,
};

export default PropertyAddress;
